import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import RegistrationPending from './pages/RegistrationPending';
import WholesalerInventory from './pages/WholesalerInventory';
import ProtectedRoute from './features/wholesaler/components/ProtectedRoute';
import WholesalerProductDetails from './pages/WholesalerProductDetails';
import WholesalerAdd from './pages/WholesalerAddProduct';
import WholesalerOrders from './pages/WholesalerOrders';
import WholesalerConnections from './pages/WholesalerConnections';
import WholesalerProfile from './pages/WholesalerProfile';
import WholesalerAddConnection from './pages/WholesalerAddConnection';

import ProtectedRouteRetailer from './features/retailer/components/ProtectedRouteRetailer';
import RetailerDashboard from './pages/retailer/RetailerDashboard';
import RetailerCart from './pages/retailer/RetailerCart';
import RetailerProductDetails from './pages/retailer/RetailerProductDetails';
import RetailerAddConnection from './pages/retailer/RetailerAddConnection';
import RetailerOrders from './pages/retailer/RetailerOrders';
import RetailerConnections from './pages/retailer/RetailerConnections';
import RetailerProfile from './pages/retailer/RetailerProfile';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <SignUp />,
  },
  {
    path: "/registration-pending",
    element: <RegistrationPending />,
  },
  {
    path: "/wholesaler/inventory",
    element: (
      <ProtectedRoute>
        <WholesalerInventory />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/inventory/add",
    element: (
      <ProtectedRoute>
        <WholesalerAdd />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/inventory/:productId",
    element: (
      <ProtectedRoute>
        <WholesalerProductDetails />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/orders/requests",
    element: (
      <ProtectedRoute>
        <WholesalerOrders type="pending" />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/orders/approved",
    element: (
      <ProtectedRoute>
        <WholesalerOrders type="approved" />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/connections/requests",
    element: (
      <ProtectedRoute>
        <WholesalerConnections type="pending"/>
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/connections/approved",
    element: (
      <ProtectedRoute>
        <WholesalerConnections type="approved" />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/connections/add",
    element: (
      <ProtectedRoute>
        <WholesalerAddConnection />
      </ProtectedRoute>
    ),
  },
  {
    path: "/wholesaler/profile",
    element: (
      <ProtectedRoute>
        <WholesalerProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/retailer/dashboard",
    element: (
      <ProtectedRouteRetailer>
        <RetailerDashboard />
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/cart",
    element: (
      <ProtectedRouteRetailer>
        <RetailerCart />
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/dashboard/:productId",
    element: (
      <ProtectedRouteRetailer>
        <RetailerProductDetails />
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/connections/add",
    element: (
      <ProtectedRouteRetailer>
        <RetailerAddConnection />
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/orders/requests",
    element: (
      <ProtectedRouteRetailer>
        <RetailerOrders type="pending" />
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/orders/approved",
    element: (
      <ProtectedRouteRetailer>
        <RetailerOrders type="approved" />
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/connections/requests",
    element: (
      <ProtectedRouteRetailer>
        <RetailerConnections type="pending"/>
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/connections/approved",
    element: (
      <ProtectedRouteRetailer>
        <RetailerConnections type="approved" />
      </ProtectedRouteRetailer>
    ),
  },
  {
    path: "/retailer/profile",
    element: (
      <ProtectedRouteRetailer>
        <RetailerProfile />
      </ProtectedRouteRetailer>
    ),
  },
]);

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <ToastContainer position="top-right" autoClose={3000} />
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
